export default __webpack_public_path__ + "static/media/Rectangle 69.3eb342c3.svg";